module.exports = __webpack_public_path__ + "img/icon-score8.b7a00287.svg";